import { Migration } from '~core/models/invoice.models';
import { PaymentMethod } from '~core/models/payment.models';
import { Money } from '~core/models/tax-rules.models';

export const enumToArray = <T extends Record<string, string | number>>(
  enumObj: T
): Array<{ key: string; value: T[keyof T] }> => {
  return Object.keys(enumObj)
    .filter(key => enumObj[key as keyof T] !== '')
    .map(key => ({
      key,
      value: enumObj[key as keyof T]
    }));
};

export function formatMoney(money?: Money, currency?: string): string {
  const _currency = money?.currency || currency;
  const amountNum = Number(money?.amount);
  const amount = isNaN(amountNum) ? 0 : amountNum;
  return `${amount.toLocaleString('fr-FR', { maximumFractionDigits: 0 })} ${_currency}`;
}

export function isValidMigration(
  data: Migration | any[] | undefined | null
): data is Migration {
  return (
    !!data &&
    !Array.isArray(data) &&
    'migrated_from' in data &&
    data.migrated_from === 'fne_v1'
  );
}

export function getFullName(...names: (string | null | undefined)[]): string {
  return names.filter(Boolean).join(' ');
}

export function getPaymentProcessorLogo(paymentMethod: PaymentMethod): string {
  switch (paymentMethod) {
    case PaymentMethod.ORANGE_MONEY:
      return '/assets/icons/orange.png';
    case PaymentMethod.MTN_MONEY:
      return '/assets/icons/mtn.png';
    case PaymentMethod.MOOV_MONEY:
      return '/assets/icons/moov.png';
    case PaymentMethod.WAVE_MONEY:
      return '/assets/icons/wave.png';
    case PaymentMethod.TPE:
      return '/assets/icons/tpe.png';
    case PaymentMethod.VISA:
      return '/assets/icons/visa.png';
    case PaymentMethod.MASTERCARD:
      return '/assets/icons/mastercard.png';
    default:
      return '/assets/icons/wallet.svg';
  }
}
